import { Col, Container, Row } from 'react-bootstrap'
import img1 from '../Assets/images/Group 13.png'
import { useTranslation } from 'react-i18next';
import k12 from '../Assets/images/image 7.png'
import arForLife from "../Assets/images/image 4.png"
import arabic_specialized from "../Assets/images/image 2.png"
import arabic_calligraphy from "../Assets/images/image 5.png"
import kalemon_levels from "../Assets/images/image 6.png"
import Conversation from "../Assets/images/Conversation Programs.png"
import Training from "../Assets/images/TeacherTrainingDiploma.png"
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';
import { useState } from 'react';

const AllPrograms = () => {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const data = [
        {
            img: k12,
            title: t("all_programs.k12_title"),
            description: t("all_programs.k12_desc"),
            link: "/kalemon-k12",
        },
        {
            img: arForLife,
            title: t("all_programs.life_title"),
            description: t("all_programs.life_desc"),
            link: "/arabic-for-life",
        },
        {
            img: arabic_specialized,
            title: t("all_programs.specialized_title"),
            description: t("all_programs.specialized_desc"),
            link: "/arabic-specialized",
        },
        {
            img: arabic_calligraphy,
            title: t("all_programs.calligraphy_title"),
            description: t("all_programs.calligraphy_desc"),
            link: "/arabic-calligraphy",
        },
        {
            img: kalemon_levels,
            title: t("all_programs.levels_title"),
            description: t("all_programs.levels_desc"),
            link: "/kalemon-levels",
        },
        {
            img: Conversation,
            title: t("all_programs.conversation_title"),
            description: t("all_programs.conversation_desc"),
            link: "/conversation-program",
        },
        {
            img: Training,
            title: t("all_programs.training_title"),
            description: t("all_programs.training_desc"),
            link: "/teachers",
        }
    ];

    return (
        <div className='all-programs'>
            <div className='ap-first-section'>
                <Row>
                    <Col lg={6} className='d-flex flex-column justify-content-center align-items-center text-start'>
                        <h2>{t("all_programs.heading")}</h2>
                        <p>{t("all_programs.subheading")}</p>
                    </Col>
                    <Col lg={6}><img src={img1} alt="" /></Col>
                </Row>
            </div>

            <div className='ap-second-section d-flex justify-content-start px-5 align-items-center'>
                <button className='btn' onClick={() => setIsModalOpen(true)}>
                    {t("start_now")}
                </button>
            </div>

            <Container>
                <div className='ap-cards'>
                    <h2>{t("all_programs.programs_heading")}</h2>
                    <p className='mb-5 header-text'>{t("all_programs.programs_text")}</p>

                    <Row className='mb-5'>
                        {data.map((item, index) => (
                            <Col lg={6} md={12} className='mb-4' key={index}>
                                <div className='ap-card'>
                                    <img src={item.img} alt='' />
                                    <div>
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>

                                        <Link
                                            to={item.link}
                                            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                            className='btn'
                                        >
                                            {t("all_programs.more")}
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>

            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"}
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>
    )
}

export default AllPrograms;
